<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1) & closeGA4Click('click', 'cerrar', 'aviso de privacidad')">
      <h2>
        X
      </h2>
    </div>
    <div id="privacy-policy" class="privacy-policy" v-html="privacy"></div>
  </div>
</template>

<script>
import Axios from "axios";
import tagFunctions from "@/utils/tagFunctions.js";
export default {
  name: "Politics",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data() {
    return {
      privacy: "",
    };
  },
  async mounted() {
    window.scrollTo(0,0)
    tagFunctions.user_interactionPush(
      "view",
      "aviso de privacidad",
      "footer"
    );
    //let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios;rev=2/privacidad/aviso/V2')
    let serviceResponse = await Axios.get(
      "https://api-mx-marketing.azure-api.net/sitios/privacidad/aviso"
    );
    this.privacy = serviceResponse.data
      .replace("{", "")
      .replace('"body":"', "")
      .replace(
        `";
        }`,
        ""
      )
      .replaceAll("<br>", "");
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.container {
  background-image: url("/Back-2.png");
  background-position: center;
  background-size: 104%;
}

.goBackBtn {
  display: flex;
  flex-direction: row;
  //width: 130px;
  width: 70px;
  background-color: transparent;
  border: none;
  color: $green-pantone-7729c;
  font-family: $font-dinbold;
  //margin-left: 2rem;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $green-pantone-7729c !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    //width: 80px;
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}

.privacy-policy {
  padding-inline: 2vw;
  font-family: "Wood-Bonnet-Grotesque" !important;
  font-size: 1.7vw !important;
  margin-right: 16.2pt !important;
  margin-left: 16.2pt !important;
  color: $green-pantone-7729c !important;
  padding-bottom: 5vw;
  padding-top: 6vw !important;
  h3,
  p {
    margin: 0;
    margin-bottom: 0pt !important;
  }
  @media (max-width: 768px) {
    font-size: 5.5vw !important;
    margin-right: 10.2pt !important;
    margin-left: 10.2pt !important;
    padding-top: 14vw !important;
  }
}
</style>
